var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4522_1309)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "#B41411"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12C13.0909 12 10.1795 14.0733 9 17C10.1795 19.9267 13.0909 22 16.5 22C19.9091 22 22.8205 19.9267 24 17C22.8205 14.0733 19.9091 12 16.5 12ZM16.5 20.3333C14.6182 20.3333 13.0909 18.84 13.0909 17C13.0909 15.16 14.6182 13.6667 16.5 13.6667C18.3818 13.6667 19.9091 15.16 19.9091 17C19.9091 18.84 18.3818 20.3333 16.5 20.3333ZM16.5 15C15.3682 15 14.4545 15.8933 14.4545 17C14.4545 18.1067 15.3682 19 16.5 19C17.6318 19 18.5455 18.1067 18.5455 17C18.5455 15.8933 17.6318 15 16.5 15Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4522_1309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.04145710dee58329a42a911d466fa2df.svg";
export { ForwardRef as ReactComponent };